<template>
    <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="branchValidation">
        <b-form @submit.prevent="onSubmit">
          <b-row>
            <b-col class="d-flex justify-content-between" cols="12">
              <h3> {{ mainTitle }} </h3>
              
              <feather-icon
                size="20"
                class="cursor-pointer"
                @click="modalOpen = false"
                icon="XIcon"
              />
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col cols="12" class="mt-1">
              <form-select
                rules="required"
                label="نوع التبرع"
                id="type"
                v-model="form.type"
                :reduce="(x) => x.slug"
                :getOptionLabel="(x) => x.name"
                :options="[
                  {name : 'تبرع عيني' , slug:'in_kind_donations' } ,
                  {name : 'تبرع مالي' , slug:'bank_donations'} ,
                  {name : 'تبرع مركبة' , slug:'machines'},
                ]"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                  rules="required"
                  label="مكان ورود التبرع"
                  id="place_type"
                  v-model="form.place_type"
                  :reduce="(x) => x.slug"
                  :getOptionLabel="(x) => x.name"
                  :options="[
                    {name : 'دولة' , slug:'country' } ,
                    {name : 'منطقة حرة' , slug:'freezone'}
                  ]"
                  :readonly="form.type === 'bank_donation'"
              />
            </b-col>
            <b-col cols="12" v-if="form.place_type === 'country'">
              <form-select
                  rules="required"
                  label="الدولة"
                  id="country"
                  v-model="form.country_id"
                  :reduce="(x) => x"
                  :getOptionLabel="(x) => x.name"
                  ep="v2/guest/selects/countries"
              />
            </b-col>
            <b-col cols="12" v-if="form.place_type === 'freezone'">
              <form-input
                  v-model="form.free_zone_name"
                  rules="required"
                  label="اسم المنطقة الحرة"
              />
            </b-col>
            <b-col cols="12" v-if="form.place_type === 'country' && form.type !== 'bank_donations'">
              <form-select
                rules="required"
                label="المعبر الحدودي"
                id="route"
                v-model="form.border_crossing_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name"
                ep="v2/selects/border-crossings"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="رقم المحضر"
                id="meeting_minute"
                v-model="form.meeting_minute_id"
                :getOptionLabel="(x) => x.meeting_minutes_label"
                :reduce="(x) => x"
                ep="v2/selects/meeting-minutes"
              />
              
              <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
              </small>
            </b-col>
            <b-col cols="12">
              <form-file-input
                  placeholder="اختر ملفاً"
                  id="document"
                  accept=".doc,.pdf,.docx"
                  v-model="form.identification_file"
                  label="صورة عن الهوية أو جواز سفر المتبرع"
                  rules="required"
              />
            </b-col>
          </b-row>
          <!-- تبرع بنكي -->
          <b-row v-if="form.type === 'bank_donations'">
            <b-col cols="12">
            <form-select
              rules="required"
              label="رقم الحساب البنكي"
              id="account_no"
              v-model="form.ngo_bank_account_id"
              :reduce="(x) => x"
              :getOptionLabel="(x) => x.account_no"
              ep="v2/selects/bank-accounts"
            />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.donated_amount"
                  rules="required|integer"
                  label="مبلغ التبرع"
              />
            </b-col>
            <b-col cols="12">
            <form-select
              rules="required"
              label="العملة المُتبرع بها"
              id="currency_types"
              v-model="form.currency_type_id"
              :reduce="(x) => x"
              :getOptionLabel="(x) => x.name_ar"
              ep="v2/selects/currency-types"
            />
            </b-col>
          </b-row>
          <!--------------->
          <!-- تبرع عيني -->
          <b-row  v-if="form.type === 'in_kind_donations'">
            <b-col cols="12">
              <form-textarea
                  v-model="form.description"
                  rules="required"
                  label="الوصف"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.donated_amount"
                  rules="required|integer"
                  label="كمية التبرع"
                  :charsCount="10"
              />
            </b-col>
            <b-col cols="12">
              <label for="">المُرفقات</label>
              <hr />
            </b-col>
            <!-- <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                accept=".doc,.pdf,.docx"
                v-model="form.invoice_file"
                label="الفاتورة"
              />
            </b-col>
            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                accept=".doc,.pdf,.docx"
                v-model="form.bill_of_lading_file"
                label="بوليصة الشحن الموازنة"
              />
            </b-col> -->
            <b-col cols="12">
              <form-file-input
                placeholder="اختر ملفاً"
                id="document"
                accept=".doc,.pdf,.docx"
                v-model="form.insurance_file"
                label="بيانات التبرع"
                rules="required"
              />
            </b-col>
          </b-row>
          <!--------------->
          <!-- تبرع مركبة -->
          <b-row v-if="form.type === 'machines'">
            <b-col cols="12">
              <form-select
                  rules="required"
                  label="نوع المركبة"
                  id="machine_type_id"
                  v-model="form.machine_type_id"
                  :reduce="(x) => x"
                  :getOptionLabel="(x) => x.name_ar"
                  ep="v2/selects/machine-types"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.model"
                  rules="required"
                  label="الطراز"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.structure_no"
                  rules="required"
                  label="رقم الهيكل"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.engine_number"
                  rules="required|integer"
                  label="رقم المحرك"
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.color"
                  rules="required"
                  label="اللون"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                  label="سنة الصنع"
                  id="year"
                  :options="getYears()"
                  rules="required"
                  v-model="form.year"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="نوع الوقود"
                id="fuel_type_id"
                v-model="form.fuel_type_id"
                :reduce="(x) => x"
                :getOptionLabel="(x) => x.name_ar"
                ep="v2/selects/fuel-types"
                  
              />
            </b-col>
            <b-col cols="12">
              <form-input
                  v-model="form.passengers_number"
                  rules="required|integer|min:1|max:2"
                  label="عدد الركاب"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                  rules="required"
                  label="صيغة التملك"
                  id="possessive_form_id"
                  v-model="form.possessive_form_id"
                  :reduce="(x) => x"
                  :getOptionLabel="(x) => x.name_ar"
                  ep="v2/selects/possessive-forms"
              />
            </b-col>
            <b-col cols="12">
              <form-file-input
                  placeholder="اختر ملفاً"
                  id="document"
                  label="وثيقة الملكية"
                  accept=".doc,.pdf,.docx"
                  v-model="form.ownership_doc"
                  rules="required"
              />
            </b-col>
            <b-col cols="12">
              <form-select
                rules="required"
                label="هل استفادت المنظمة من إعفاء سابق؟"
                id="tax"
                v-model="form.tax"
                :reduce="(x) => x.value"
                :getOptionLabel="(x) => x.label"
                :options="[
                  { label:'لا', value: 0 },
                  { label:'نعم', value: 1 },
                ]"
              />
            </b-col>
          </b-row>
          <!--------------->
          <hr />
          <b-row class="px-1 justify-content-end">
            <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
            <save-btn
              type="submit"
              variant="success"
              :loading="loading"
              :label="btnLabel"
            >
            </save-btn>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
  </b-sidebar>
</template>


<script>

import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BModal,
  BFormGroup,
  BFormFile,
  BFormRadio,
  BForm,
  BFormTextarea,
  BButton,
  BSidebar,
  BFormCheckbox
  
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import FormMask from "@/components/form-mask";
import { required, integer } from "@validations";
import mapSelect from "@/components/map-select";
import { ValidationProvider } from "vee-validate";
import FormImageInput from "@/components/FormImageInput.vue";
import { quillEditor } from "vue-quill-editor";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCleave from "@/components/FormCleave.vue";
import FormTextarea from "@/components/form-textarea/index.vue";
import { arrangement } from "@/utils/utils";
import { mapActions, mapGetters } from "vuex";
// import store from "../pages/transactions/store";
const initForm = {};
export default {
  components: {
    formInput,
    formTextarea,
    formSelect,
    BButton,
    BSidebar,
    FormMask,
    saveBtn,
    BRow,
    BCol,
    mapSelect,
    BCard,
    BCardText,
    BCardTitle,
    BModal,
    BFormGroup,
    BFormFile,
    BForm,
    BFormRadio,
    BFormTextarea,
    ValidationObserver,
    ValidationProvider,
    FormImageInput , 
    quillEditor ,
    FormFileInput , 
    FormCleave ,
    FormTextarea , 
    BFormCheckbox
  },
  props: {
    value: Boolean,
    title: String,
    mainTitle: {
      type: String,
      default: () => "بيانات معاملة",
    },
    btnLabel: String,
    loading: Boolean,
    intializeForm: {
      type: Object,
      default: () => initForm,
    },
  },
  computed: {
    ...mapGetters("Transactions/Transactions", ["TransactionType"]),
    modalOpen: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
    typeDonation(){
      return this.form.type;
    }
  },
  methods: {
    ...mapActions("Transactions/Transactions", ["fetchTransactionType"]),
    init(form) {
      this.form = JSON.parse(JSON.stringify(form));
    },
    async onSubmit() {
      await this.$refs.branchValidation.validate().then(async (success) => {
        if (success) {
          this.$emit("confirm", this.form);
        }
      });
    },
    getYears() {
      var x = [];
      for (let index = 1900; index < this.$moment().year(); index++) {
        x.push(`${index}`);
      }
      return x.reverse();
    },
    getArrangement(num){
      return arrangement(num)
    }
  },
  data() {
    return {
      form: {},
      required,
      integer,
    };
  },
  watch: {
    modalOpen(val) {
      if (val)
        this.$nextTick(() => {
          // this.init(this.intializeForm);
        });
    },
    typeDonation(val){
      
      // console.log("befor",this.form)
      // for (const key in this.form) {
      //   if (key !== 'type') {
      //     delete this.form[key];
      //   }
      // }
      // if(val == 'bank_donations'){
      //   this.form.place_type = 'country'
      // }
      // console.log("after",this.form)
    }
  },

};
</script>
